import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { finalize } from 'rxjs';

import { RecaptchaWidgetRegistry } from './recaptcha-widget-registry.service';

function readRecaptchaV2Token(body: unknown): string | null {
	if (typeof body !== 'object' || body === null) {
		return null;
	}

	const { recaptchaVersion, token } = body as Record<string, unknown>;
	if (recaptchaVersion === 'v2' && typeof token === 'string' && token) {
		return token;
	}

	return null;
}

// The backend verifies reCAPTCHA v2 tokens in middleware, before any business
// logic runs. A request that carries a v2 token therefore consumes it at
// Google no matter how the request ends, so the widget that produced the
// token is reset once the request settles.
export const recaptchaTokenInterceptor: HttpInterceptorFn = (req, next) => {
	const registry = inject(RecaptchaWidgetRegistry);
	const token = readRecaptchaV2Token(req.body);

	if (!token) {
		return next(req);
	}

	return next(req).pipe(finalize(() => registry.markTokenConsumed(token)));
};
